var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5567 39.8999C36.5333 39.8999 36.51 39.8999 36.4867 39.8999H20.9233C16.3033 39.5732 14.25 36.0499 14.25 32.8999C14.25 30.2632 15.6967 27.37 18.8 26.2967C18.1 22.7967 18.9634 19.53 21.2734 17.1033C24.05 14.1866 28.5067 13.0433 32.3333 14.21C35.74 15.26 38.19 17.99 39.1467 21.7933C42.0634 22.61 44.3734 24.8966 45.33 27.9999C46.4034 31.5466 45.4233 35.1866 42.7633 37.4966C41.0833 39.0366 38.8667 39.8999 36.5567 39.8999ZM20.9934 29.3999C18.6134 29.6099 17.75 31.4065 17.75 32.8999C17.75 34.4165 18.6133 36.2365 21.04 36.3999H36.4867C38.0033 36.3999 39.3333 35.8866 40.4066 34.8833C42.3666 33.18 42.4833 30.7299 41.97 29.0033C41.4567 27.2766 39.9867 25.3165 37.4433 25.0132C36.6733 24.9199 36.0667 24.3365 35.9267 23.5665C35.4134 20.4632 33.7566 18.34 31.2833 17.57C28.74 16.7767 25.6367 17.5933 23.7933 19.5299C21.9733 21.4199 21.5767 24.1032 22.6267 27.0665C22.9533 27.9765 22.4867 28.9799 21.5767 29.3066C21.39 29.3766 21.0867 29.4232 20.9934 29.3999Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 53.0833C13.0367 53.0833 4.91669 44.9633 4.91669 35C4.91669 34.0433 5.71002 33.25 6.66669 33.25C7.62335 33.25 8.41669 34.0433 8.41669 35C8.41669 41.9067 13.2233 47.6934 19.6867 49.2101L19.0567 48.16C18.5667 47.32 18.8234 46.2466 19.6634 45.7566C20.48 45.2666 21.5767 45.5233 22.0667 46.3633L24.5167 50.4467C24.8433 50.9833 24.8434 51.66 24.54 52.1967C24.2134 52.7333 23.63 53.0833 23 53.0833Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 22.75C52.3765 22.75 51.5832 21.9567 51.5832 21C51.5832 14.0934 46.7765 8.30662 40.3132 6.78996L40.9432 7.83999C41.4332 8.67999 41.1765 9.75339 40.3365 10.2434C39.5198 10.7334 38.4231 10.4767 37.9331 9.6367L35.4832 5.55337C35.1565 5.0167 35.1565 4.34003 35.4598 3.80337C35.7632 3.24337 36.3465 2.91669 36.9765 2.91669C46.9398 2.91669 55.0598 11.0367 55.0598 21C55.0831 21.9567 54.2898 22.75 53.3332 22.75Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_780",
    x: -2,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_780",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.ab1a477d6647a980b8c14414126f1c93.svg";
export { ForwardRef as ReactComponent };